<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div class="border rounded-lg overflow-hidden">
    <v-data-table
      v-model="reelsSelected"
      :headers="reelsTableHeader"
      :items="reelsFiltered"
      :loading="loading"
      :item-key="selectItemKey"
      :show-select="!noSelectable"
      :item-class="rowTableClass"
      :height="height"
      :mobile-breakpoint="0"
      :footer-props="options"
      disable-sort
      dense
      fixed-header
      checkbox-color="blue"
      loading-text="Cargando información..."
      no-results-text="El material no se encuentra o sin existencia"
      @item-selected="emitSelection"
    >
      <template #no-data>
        <span class="font-weight-bold error--text">{{ noDataText }}</span>
      </template>
      <template #header.data-table-select />
      <template #[`item.data-table-select`]="{ item, isSelected, select }">
        <v-tooltip v-if="!item.isSequentialSelectable" top color="warning">
          <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" color="grey lighten-1" v-on="on">
              mdi-information-box-outline
            </v-icon>
          </template>

          <span class="black--text">
            Para seleccionar este carrete, primero selecciona el anterior del
            mismo material.
          </span>
        </v-tooltip>

        <v-simple-checkbox
          v-else
          :disabled="item.isSelectable === false"
          :value="isSelected"
          @input="select($event)"
        />
      </template>
    </v-data-table>
  </div>
</template>

<script>
  const reelsTableSimpleHeader = [
    { text: 'Pedido Vta', value: 'PEDVTA' },
    { text: 'No. carrete', value: 'NCARR' },
    { text: 'Accept', value: 'ACEPT', align: 'center' },
    { text: 'Material', value: 'matnr' },
    { text: 'Descripción', value: 'MAKTX' },
    { text: 'Cantidad Pedida', value: 'kwmeng', align: 'right' },
    { text: 'UMB', value: 'MEINS' },
    { text: 'Centro de suministro', value: 'WERKS' },
    { text: 'Posición cotizacion', value: 'POSCOT' },
    { text: 'Número cotizacion', value: 'COTIZ', align: 'right' },
    { text: 'Fecha', value: 'ERDAT' },
    { text: 'Usuario', value: 'ERNAM' },
  ];

  const reelsTableFullHeader = [
    ...reelsTableSimpleHeader,
    { text: 'Entrega', value: 'VBELN' },
    { text: 'Pos.', value: 'POSNR' },
    { text: 'Fe.Reparto', value: 'EDATU' },
    { text: 'Numero de aviso', value: 'NOAVI' },
    { text: 'Cant. Carret.', value: 'CCARR', align: 'right' },
    { text: 'Fecha', value: 'ERDAT' },
    { text: 'Hora', value: 'ERZET' },
    { text: 'Usuario', value: 'ERNAM' },
    { text: 'Libre', value: 'LIBRE' },
  ];

  export default {
    props: {
      value: {
        type: Array,
        default: () => [],
      },

      reels: {
        type: Array,
        required: true,
      },

      search: {
        type: String,
        default: '',
      },

      selectItemKey: {
        type: String,
        default: 'NCARR',
      },

      height: {
        type: String,
        default: '250px',
      },

      fullTable: Boolean,
      noSelectable: Boolean,
      loading: Boolean,
    },

    data() {
      return {
        options: {
          itemsPerPageOptions: [20, 40, 60, { text: 'Todos', value: -1 }],
          itemsPerPage: 20,
        },
      };
    },

    computed: {
      reelsTableHeader() {
        return !this.fullTable ? reelsTableSimpleHeader : reelsTableFullHeader;
      },

      reelsSelected: {
        set(newValue) {
          this.$emit('input', newValue);
        },

        get() {
          return this.value;
        },
      },

      reelsFiltered() {
        if (!this.search) return this.reels;

        const term = this.search.toString().toLocaleLowerCase();
        return this.reels.filter((item) => {
          return (
            item.NCARR?.toLowerCase().includes(term) ||
            item.matnr?.toLowerCase().includes(term) ||
            item.MAKTX?.toLowerCase().includes(term)
          );
        });
      },

      noDataText() {
        if (this.search && this.reelsFiltered.length === 0) {
          return 'El material no se encuentra o sin existencia';
        }

        return 'No se encontro información';
      },
    },

    methods: {
      rowTableClass(item) {
        const status = item.status;

        switch (status) {
          case 'selected':
            return 'table-row selected-reel-table';
          case 'error':
            return 'table-row error-reel-table';
          default:
            return 'table-row';
        }
      },

      emitSelection(item) {
        this.$emit('itemSelected', item);
      },
    },
  };
</script>

<style>
  .error-reel-table {
    background-color: rgb(248, 87, 87) !important;
  }

  .selected-reel-table {
    background-color: rgb(181, 237, 195) !important;
  }

  .table-row {
    white-space: nowrap;
  }

  .table-row > td {
    border-bottom: 0px !important;
  }
</style>
